export default __webpack_public_path__ + "static/media/gallery_23.34f197bd.jpg";